import { requestOTP } from '../Authentication.repo'
// import AuthenticationRepo from '../Authentication.repo'

const defaultState = {
  verification: {
    otpRequest: {
      hasRequestedOTP: false,
      recipient: '',
      otp: 0, //  TODO: change from empty string to 0 for type checking, this state is only for development environment
      hashPass: '',
      fromName: ''
    }
  }
}

const getters = {
  requestOtpStates: (state) => state.verification.otpRequest
}

const actions = {
  async updateRouteName ({ commit }, route) {
    commit('setRouteName', route)
  },
  async getUserOtp ({ commit }, { phoneNumber, provider }) {
    commit('setRecipient', phoneNumber)

    const response = await requestOTP(phoneNumber, provider).catch((error) =>
      console.error(error)
    )

    if (response) {
      commit('setOtpLogin', response)
    }
  },
  async handleReset ({ commit }) {
    commit('resetRequestOtpStates')
  }
}

const mutations = {
  setRouteName: (state, route) => {
    state.verification.otpRequest.fromName = route
  },
  setRecipient: (state, phoneNumber) => {
    state.verification.otpRequest.recipient = phoneNumber
  },
  setOtpLogin: (state, response) => {
    state.verification.otpRequest.otp = response.otp
    state.verification.otpRequest.hashPass = response.hashPass
    state.verification.otpRequest.hasRequestedOTP = true
  },
  resetRequestOtpStates: (state) => {
    state.verification.otpRequest.hasRequestedOTP = false
    state.verification.otpRequest.recipient = ''
    state.verification.otpRequest.otp = ''
  }
}

export default {
  state: defaultState,
  getters,
  actions,
  mutations
}
